export default {"src":"/planos/_next/static/media/equifax-alert.dc6031f0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};